import React from 'react';
import { SlidersHorizontalIcon } from 'lucide-react';
export function BeheerButton({
  onClick,
  size = 'sm'
}: {
  onClick?: () => void;
  size?: 'sm' | 'wall';
}) {
  const wall = size === 'wall';
  return <button type="button" onClick={onClick} className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/10 bg-white/[0.03] font-medium text-ink-soft transition-colors duration-150 hover:border-white/20 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${wall ? 'h-14 px-5 text-[22px]' : 'h-10 px-4 text-[13px]'}`} data-id="element-1320" data-mp="1p1bz3j6l0kz6">
      <SlidersHorizontalIcon className={wall ? 'h-5 w-5' : 'h-4 w-4'} strokeWidth={1.75} aria-hidden data-id="element-1321" data-mp="16c5mmdwdsplt" />
      Beheer
    </button>;
}